import { ExportPaymentRequestsProps } from '@/features/approving_invoice_reports/components/ExportPaymentRequests/types';
import { ActionMenuProps } from '@moneyforward/ap-frontend-components';
import ErrorBoundary from 'antd/es/alert/ErrorBoundary';
import { FC, memo, useMemo } from 'react';
import { ActionMenus } from './ActionMenus';

const InnerExportPaymentRequests: FC<ExportPaymentRequestsProps> = memo(
  ({ isDisabled, onExport, isLoading }) => {
    const dropDownProps: ActionMenuProps['dropDownProps'] = useMemo(
      () => ({
        destroyPopupOnHide: true,
      }),
      []
    );
    return (
      <>
        <ActionMenus
          onExport={onExport}
          isDisabled={isDisabled}
          dropDownProps={dropDownProps}
          isLoading={isLoading}
        />
      </>
    );
  }
);

InnerExportPaymentRequests.displayName = 'InnerExportPaymentRequests';

export const ExportPaymentRequests: FC<ExportPaymentRequestsProps> = memo(
  ({ isDisabled, onExport, isLoading }) => {
    return (
      <ErrorBoundary>
        <InnerExportPaymentRequests
          isDisabled={isDisabled}
          onExport={onExport}
          isLoading={isLoading}
        />
      </ErrorBoundary>
    );
  }
);

ExportPaymentRequests.displayName = 'ExportPaymentRequests';
